exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".swiper-container{width:560px}.icon-ghost{color:#039be5;font-weight:700}.icon-settings{color:#43a047;font-weight:700}.icon-rocket{color:#f57c00;font-weight:700}.icon-grid{color:#d81b60;font-weight:700}.version{margin-right:1px;background-color:#03a9f4}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-308fdbba","scoped":false,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/catalogs/CatalogDevops.vue
// module id = 433
// module chunks = 1